// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3OP1z","detailsBorder":"styles_detailsBorder__3SejM"};